import React from 'react';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Text, Title, ButtonContainer, SimpleButton } from './styles';
type Props = {
  show: boolean;
  onClose: () => void;
};

const FlightsExchangeSuccess = ({ show, onClose }: Props) => {
  const { t } = useStoreTranslation();
  return (
    <ApplicationOverlayContent sidebar show={show} onClose={onClose} backgroundColor="#f0e2ff" zIndex={17}>
      <Container>
        <Title>{t('flightsExchange.success.title')}</Title>
        <Text>{t('flightsExchange.success.text')}</Text>
        <ButtonContainer>
          <SimpleButton onClick={onClose} value={t('flightsExchange.success.button')} />
        </ButtonContainer>
      </Container>
    </ApplicationOverlayContent>
  );
};

export default FlightsExchangeSuccess;
